export function ComplianceReportsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Compliance Reports</h1>
      <p className="text-muted-foreground">Generate and view compliance reports.</p>
    </div>
  );
}
